import { atom } from 'jotai';

import { EquipmentBrowserViewResponse } from '@repo/sdk/models/components';

/**
 * This is set when we fetch equipment browser information.
 */
export const equipmentBrowserResponseAtom = atom<EquipmentBrowserViewResponse | undefined>(
  undefined
);
equipmentBrowserResponseAtom.debugLabel = 'equipmentBrowserResponseAtom';

/**
 * The default (All Equipment) view's response, whatever view is showing. The
 * Faulted and Manual devices groups and their counts are computed from it.
 */
export const allEquipmentResponseAtom = atom<EquipmentBrowserViewResponse | undefined>(undefined);
allEquipmentResponseAtom.debugLabel = 'allEquipmentResponseAtom';

export const equipmentBrowserLoadingAtom = atom<boolean>(false);
equipmentBrowserLoadingAtom.debugLabel = 'equipmentBrowserLoadingAtom';
